module.exports = __webpack_public_path__ + "img/funnel.a2e4c2ae.svg";